import React, { useEffect, useState } from "react";
import ContratoForm from "./ContratoForm";
import ContratoPDF from "./ContratoPDF";
import styled, { keyframes } from "styled-components";
import { RiArrowGoBackFill } from "react-icons/ri";
import { pdf } from "@react-pdf/renderer";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDoc, collection } from "firebase/firestore";
import { storage, db } from "./Firebase";
import ContratoPDFDocument from "./ContratoPDFDocument";
import { userName, userEmail } from "./UserData";

const Contenedor = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;
const ContenedorButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const AnimatedIcon = styled(RiArrowGoBackFill)`
  cursor: pointer;
  &:hover {
    animation: ${bounce} 1s ease infinite;
  }
`;

const ContratoApp = () => {
  const [contratoGenerado, setContratoGenerado] = useState(null);
  const [firmaCorreo, setFirmaCorreo] = useState("");
  const [correoUsuario, setCorreoUsuario] = useState("");

  useEffect(() => {
    setFirmaCorreo(userName); // Actualiza firmaCorreo con userName
    setCorreoUsuario(userEmail);
  }, []);

  const formulario = () => {
    setContratoGenerado(null);
  };

  const generarContrato = async (contratoData) => {
    const blob = await pdf(
      <ContratoPDFDocument datos={contratoData} />
    ).toBlob();

    // Ahora se guarda usando contratoNumero
    const fileRef = ref(
      storage,
      `contratos/Contrato-${contratoData.contratoNumero}.pdf`
    );
    await uploadBytes(fileRef, blob);

    const downloadURL = await getDownloadURL(fileRef);

    // enlace para la confirmación de contrato
    const confirmacionURL = `${window.location.origin}/confirmacion-contrato?contrato=${contratoData.contratoNumero}`;

    if (contratoData.emailCliente && contratoData.emailCliente.includes("@")) {
      await addDoc(collection(db, "mail"), {
        to: contratoData.emailCliente,
        cc: [correoUsuario, "rojas_dario@catainternacional.com"],
        from: `"CATA Internacional" <${correoUsuario}>`,
        replyTo: correoUsuario,
        message: {
          subject: `Contrato - ${contratoData.nombreApellido}`,
          html: `
            <p style="margin: 0px; font-weight: bold;">Estimado/a ${contratoData.nombreApellido},</p>
            <br>
            <p style="margin: 0px;">Adjuntamos el contrato generado en el siguiente enlace:</p>
            <p style="margin: 0px;"><a href="${downloadURL}" target="_blank">Descargar PDF</a></p>
            <br>
            <p style="margin: 0px;">Puede confirmar la aceptación del contrato de forma digital o bien subir el contrato firmado a través del siguiente enlace:</p>
            <p style="margin: 0px;"><a href="${confirmacionURL}" target="_blank">Confirmar Contrato</a></p>
            <br>
            <p style="margin: 0px;">Atentamente,</p>
            <p style="margin: 0px;">${firmaCorreo}</p>
            <br>
            <hr>
            <p style="margin: 0px; font-size: 12px; color: #555;">
              Este es un correo automático generado por el sistema de contratos de CATA Internacional.
            </p>
          `,
        },
      });
    }

    setContratoGenerado(contratoData);
  };

  return (
    <Contenedor>
      {contratoGenerado ? (
        <ContenedorButton>
          <ContratoPDF contratoData={contratoGenerado} />
          <AnimatedIcon onClick={formulario} size={30} />
          <p>Volver al formulario</p>
        </ContenedorButton>
      ) : (
        <ContratoForm generarContrato={generarContrato} />
      )}
    </Contenedor>
  );
};

export default ContratoApp;
